import script from "./TabbedDashboardPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./TabbedDashboardPanel.vue?vue&type=script&setup=true&lang=js"

import "./TabbedDashboardPanel.vue?vue&type=style&index=0&id=6245e341&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6245e341"]])

export default __exports__